/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * BUG-33 — block empty search submissions, silently.
 *
 * Submitting the header search with nothing typed sent the shopper to
 * /search?q= , an empty results page.
 *
 * The one that actually bites is **Enter inside the input**: AI Search Boost
 * binds its own keydown handler and navigates programmatically, so neither the
 * native `required` validation nor a submit listener ever runs. That is why the
 * search button looked fixed while Enter still jumped to /search?q= . The guard
 * therefore runs in the CAPTURE phase on document, ahead of USF's handler, and
 * calls stopImmediatePropagation() to stop it.
 *
 * No `required` attribute and no reportValidity() call: both make the browser
 * show its "Please fill out this field." bubble, which is not wanted here. An
 * empty submit simply does nothing and focus stays in the field.
 *
 * We only interfere when the trimmed value is empty, so a real query is never
 * touched and USF search keeps working normally. Scoped to inputs named "q"
 * inside form[role="search"] — the collection and search templates also carry
 * hidden inputs named "q" (vendor/type filters) whose forms must keep submitting.
 */
(function () {
  function isEmptySearchField(el) {
    if (!el || !el.matches || !el.matches('input[name="q"]')) return false;
    var form = el.form || el.closest('form');
    if (!form || !form.matches('form[role="search"]')) return false;
    return el.value.trim() === '';
  }

  // Enter inside the field — capture phase, ahead of the search app.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.keyCode !== 13) return;
    if (!isEmptySearchField(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.target.focus();
  }, true);

  // Submit button / whitespace-only input.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[role="search"]')) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || input.value.trim() !== '') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    input.focus();
  }, true);
})();


/**
 * BUG-31 — give every search input an accessible name.
 *
 * The header input (sections/header-g2m.liquid) already carries an aria-label.
 * The one that actually fails is the big search field AI Search Boost renders on
 * the results page (form.usf-sr-inputbox): ~838px wide, visible, and with no
 * aria-label, no aria-labelledby, no <label>, no title and not even a
 * placeholder — a screen reader announces it as bare "edit text". That is a
 * WCAG 4.1.2 failure.
 *
 * Fixed from the THEME rather than the app: we never modify app code or config,
 * we only add a missing accessibility attribute to the rendered DOM. If the app
 * ever ships its own label, hasAccessibleName() sees it and we leave it alone.
 *
 * The label comes from window.languages.searchInputLabel (layout/theme.liquid),
 * so it stays translated across all 9 locales rather than hard-coded English.
 *
 * USF re-renders its input on search/filter, so this re-runs on mutation,
 * debounced to keep it cheap.
 */
(function () {
  var FALLBACK = 'Search';

  function labelText() {
    return (window.languages && window.languages.searchInputLabel) || FALLBACK;
  }

  function hasAccessibleName(el) {
    if (el.getAttribute('aria-label')) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    if (el.id) {
      try {
        if (document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]')) return true;
      } catch (e) {}
    }
    if (el.closest('label')) return true;
    if (el.getAttribute('title')) return true;
    return false;
  }

  function labelSearchInputs() {
    var inputs = document.querySelectorAll('input[name="q"]:not([type="hidden"]), input[type="search"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!hasAccessibleName(inputs[i])) {
        inputs[i].setAttribute('aria-label', labelText());
      }
    }
  }

  function run() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', labelSearchInputs);
    } else {
      labelSearchInputs();
    }
  }
  run();

  var timer;
  try {
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(labelSearchInputs, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
